import { css } from "styled-components"

export const servicePageHeader = css`

  /* @temp @TODO - extract this somewhere (it's for fullwidth) */
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  height: 763px;
  overflow-y: hidden;

  .hero-container {
    position: relative;
  }

  .content {

    position: relative;
    min-height: 538px;

    &--center-y {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    
  }

  .service-page-header-icon {
    margin-bottom: 10px;
    width: 80px;
    height: 50px;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .heading {
    margin-bottom: 30px;
    max-width: 440px;
    font-size: 60px;
  }
  
  .right-hero-container {
    width: 70vw;
    max-width: 1350px;
    height: 568px;
    border-radius: 35px 0 0 0;
    position: absolute;
    bottom: 0;
    left: 650px;
    overflow: hidden;
   
    background-size: contain;

    @media (min-width: 1800px) {
      background-size: cover;
      background-position-y: -140px;
    }
  }

`